import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class DsoService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  get = () => this.http.get<[]>(this.endpoint(`socrates/authz/api/dsos?$expand=users`));
}
